// extracted by mini-css-extract-plugin
export default {"heading":"_391We1aKKqL89jFRyt8HMR","story":"_6MdEnTtudWOLmhaktXbSQt","storyTitle":"_1FfWVOPSWRg8LWVmfTA8PC","storyContent":"_7FPqXrNPSf9ac6VNcqDB55"};